var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mls-tab-wrap"},[_c('div',{ref:"table"})])
}
var staticRenderFns = []

export { render, staticRenderFns }